import InlineSvg from 'approot/shared/inline-svg/inline-svg';
import TooltipWrapper from './tooltip-wrapper';
import { TooltipInfoStyled } from './tooltip-info.style';

type Props = {
  hoverText?: string;
  hoverHeading?: string;
  multiline?: boolean;
};

const TooltipInfo = ({ hoverText, hoverHeading, multiline = false }: Props) => {
  return (
    <TooltipInfoStyled data-selector="tool-tip">
      <TooltipWrapper
        multiline={multiline}
        hoverHeading={hoverHeading}
        hoverText={hoverText}
      >
        <span tabIndex={0}>
          <InlineSvg id="icon_information" />
        </span>
      </TooltipWrapper>
    </TooltipInfoStyled>
  );
};

export default TooltipInfo;
